import React, { useState, useRef, useEffect } from 'react';

import './pion-content-note.scss';
import { withStopPropagation } from '../../../utils';
import PionExpandButton from '../PionExpandButton';
import { PionType } from '../../../type';
import withUrlParser from 'hoc/withUrlParser';

const useContentToggle = (contentRef: any, wrapperRef: any) => {
  const [withExpandButton, setWithExpandButton] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [contentHeight, setContentHeight] = useState<string | null>(null);

  // setTimeout added in order to handle case when content text cut by wrapper
  // There is case at some content lenght when content renders
  // with one height and then text wraps and bring about icreasing of content height,
  // but Show more button is not shown
  useEffect(() => {
    setTimeout(() => {
      setWithExpandButton(
        contentRef.current?.offsetHeight > wrapperRef.current?.offsetHeight,
      );
    }, 100);
  }, []);

  const toggleContent = () => {
    const blockHeight = `${contentRef.current.offsetHeight}px`;
    setIsExpanded(!isExpanded);
    setContentHeight(!isExpanded ? blockHeight : null);
  };

  return {
    withExpandButton,
    isExpanded,
    contentHeight,
    toggleContent,
  };
};

type PionNoteContent = {
  pion: PionType;
  lang: string;
  convertUrlsToAnchorTags: (text: string) => {};
};

const PionNoteContent = ({
  pion,
  lang,
  convertUrlsToAnchorTags,
}: PionNoteContent) => {
  const MAX_WRAPPER_HEIGHT: number = 55;
  const contentRef = useRef(null);
  const wrapperRef = useRef(null);
  const {
    withExpandButton,
    isExpanded,
    contentHeight,
    toggleContent,
  } = useContentToggle(contentRef, wrapperRef);

  const getNoteContent = () => {
    if (!pion.getIn(['payload', 'content'])) {
      return '';
    }

    const delimiter = '***';
    const parts = pion.getIn(['payload', 'content']).split(delimiter);
    return parts[parts.length - 1].trim();
  };

  return (
    <>
      <div className='pion-content-note'>
        <div
          className='pion-content-note__content'
          style={{ maxHeight: contentHeight || `${MAX_WRAPPER_HEIGHT}px` }}
          ref={wrapperRef}
        >
          <div ref={contentRef}>
            {convertUrlsToAnchorTags(getNoteContent())}
          </div>
        </div>
      </div>
      {withExpandButton && (
        <PionExpandButton
          expanded={isExpanded}
          onClick={withStopPropagation(toggleContent)}
          lang={lang}
        />
      )}
    </>
  );
};

export default withUrlParser(PionNoteContent);
